/*
 * @Author: huangzq
 * @Date: 2019-09-27 10:46:37
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-02 21:40:43
 * @Desc: 营销资料页面
*/
<template>
  <div class="marketing-data">
    <mk-tabs-biz
      v-model="tabName"
      :tab-pane="tabPane"
      class="el-tabs-mk-ui"
    />

    <div class="component-tab-wrapper">
      <component
        :is="tabName+'-tab'"
        class="component-tab"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ArticleTab from './components/article-tab'
import CaseTab from './components/case-tab'
import FriendTab from './components/friend-tab'
import FormTab from './components/form-tab'
import PosterTab from './components/poster-tab'
import H5Tab from './components/h5-tab'
import BrochureTab from './components/brochure-tab'
import VideoMarktingTab from './components/video-markting-tab'

export default {
  name: 'MarketingData',
  components: {
    ArticleTab,
    CaseTab,
    FriendTab,
    FormTab,
    PosterTab,
    H5Tab,
    BrochureTab,
    VideoMarktingTab
  },
  data () {
    return {
      tabName: 'article'
    }
  },
  computed: {
    ...mapGetters('system', ['isShowBetaFunc']),

    tabPane () {
      let tab = [
        {
          name: 'article',
          label: '文章'
        },
        {
          name: 'case',
          label: '案例'
        },
        {
          name: 'friend',
          label: '朋友圈'
        },
        {
          name: 'form',
          label: '表单'
        },
        {
          name: 'poster',
          label: '海报'
        },
        {
          name: 'h5',
          label: 'H5'
        },
        {
          name: 'brochure',
          label: '宣传册'
        },
        {
          name: 'video-markting',
          label: '营销视频'
        }
      ]

      // 如果isShowBetaFunc为true，则展示h5
      // if (this.isShowBetaFunc) {
      // tab.push({
      //   name: 'h5',
      //   label: 'H5'
      // })
      // }

      return tab
    }
  },
  watch: {
    tabName (name) {
      window.sessionStorage.setItem('MarketingMterialTabName', name)
    }
  },
  created () {
    this.tabName = window.sessionStorage.getItem('MarketingMterialTabName') || 'article'
  },
  destroyed () {
    window.sessionStorage.setItem('MarketingMterialTabName', 'article')
  }
}
</script>

<style lang='scss' scoped>
.marketing-data {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  overflow: hidden;

  .component-tab-wrapper {
    flex: 1;
    overflow: hidden;

    .component-tab {
      display: flex;
      flex-direction: column;
      position: relative;
      height: 100%;
      overflow: hidden;
    }
  }

  // /deep/ .el-tabs__nav-scroll {
  //   .el-tabs__item {
  //     font-size: 16px;
  //     height: 60px;
  //     line-height: 60px;
  //     padding: 0 30px;
  //     font-weight: 500;
  //   }

  //   .el-tabs__item.is-active {
  //     color: #009cff !important;
  //   }

  //   .el-tabs__active-bar {
  //     background: #009cff !important;
  //   }
  // }

  // /deep/ .el-tabs__active-bar {
  //   padding: 0 10px;
  //   margin-left: -10px;
  // }

  // /deep/ .el-tabs__nav-wrap {
  //   padding: 0 !important;
  // }
}
</style>
